<template>
  <div class="upload-container">
    <!-- PREVIEW -->
    <div v-if="previewType === 'image'" class="preview-wrapper">
      <img :src="previewUrl" alt="Preview KTP" />

      <button
        type="button"
        class="delete-btn"
        @click="removeFile"
      >
        <svg width="16" height="18" viewBox="0 0 16 18" fill="none" xmlns="http://www.w3.org/2000/svg">
          <path d="M3 18C2.45 18 1.97917 17.8042 1.5875 17.4125C1.19583 17.0208 1 16.55 1 16V3H0V1H5V0H11V1H16V3H15V16C15 16.55 14.8042 17.0208 14.4125 17.4125C14.0208 17.8042 13.55 18 13 18H3ZM5 14H7V5H5V14ZM9 14H11V5H9V14Z" fill="#F85F35"/>
        </svg>
      </button>
    </div>

    <!-- FILE PREVIEW (PDF, DLL) -->
    <div v-else-if="previewType === 'file'" class="file-preview">
      <div class="file-info">
        <div class="file-icon">
          <!-- icon file/pdf -->
          <svg width="28" height="32" viewBox="0 0 24 24">
            <path d="..." fill="#6D6F7A"/>
          </svg>
        </div>

        <div class="file-meta">
          <p class="file-name">{{ modelValue.name }}</p>
          <p class="file-size">{{ formatSize(modelValue.size) }}</p>
        </div>
      </div>

      <button
        type="button"
        class="delete-btn"
        @click="removeFile"
      >
        <svg width="16" height="18" viewBox="0 0 16 18" fill="none" xmlns="http://www.w3.org/2000/svg">
          <path d="M3 18C2.45 18 1.97917 17.8042 1.5875 17.4125C1.19583 17.0208 1 16.55 1 16V3H0V1H5V0H11V1H16V3H15V16C15 16.55 14.8042 17.0208 14.4125 17.4125C14.0208 17.8042 13.55 18 13 18H3ZM5 14H7V5H5V14ZM9 14H11V5H9V14Z" fill="#F85F35"/>
        </svg>
      </button>
    </div>

    <!-- DROPZONE -->
    <div
      v-else
      class="upload-field"
      :class="{ dragover, disabled }"
      @dragover.prevent="onDragOver"
      @dragleave="onDragLeave"
      @drop.prevent="onDrop"
    >
      <input
        ref="fileInput"
        type="file"
        class="hidden-input"
        :accept="accept"
        :disabled="disabled"
        @change="onFileChange"
      />

      <div class="content">
        <div class="icon">
          <slot name="icon">
            <svg width="22" height="18" viewBox="0 0 22 18" fill="none" xmlns="http://www.w3.org/2000/svg">
              <path d="M12.8571 9.64286H18.2143V7.5H12.8571V9.64286ZM12.8571 6.42857H18.2143V4.28571H12.8571V6.42857ZM3.21429 12.8571H11.7857V12.2679C11.7857 11.4643 11.3929 10.8259 10.6071 10.3527C9.82143 9.87946 8.78572 9.64286 7.5 9.64286C6.21429 9.64286 5.17857 9.87946 4.39286 10.3527C3.60714 10.8259 3.21429 11.4643 3.21429 12.2679V12.8571ZM7.5 8.57143C8.08929 8.57143 8.59375 8.36161 9.01339 7.94196C9.43304 7.52232 9.64286 7.01786 9.64286 6.42857C9.64286 5.83929 9.43304 5.33482 9.01339 4.91518C8.59375 4.49554 8.08929 4.28571 7.5 4.28571C6.91071 4.28571 6.40625 4.49554 5.98661 4.91518C5.56696 5.33482 5.35714 5.83929 5.35714 6.42857C5.35714 7.01786 5.56696 7.52232 5.98661 7.94196C6.40625 8.36161 6.91071 8.57143 7.5 8.57143ZM2.14286 17.1429C1.55357 17.1429 1.04911 16.933 0.629464 16.5134C0.209821 16.0937 0 15.5893 0 15V2.14286C0 1.55357 0.209821 1.04911 0.629464 0.629464C1.04911 0.209821 1.55357 0 2.14286 0H19.2857C19.875 0 20.3795 0.209821 20.7991 0.629464C21.2188 1.04911 21.4286 1.55357 21.4286 2.14286V15C21.4286 15.5893 21.2188 16.0937 20.7991 16.5134C20.3795 16.933 19.875 17.1429 19.2857 17.1429H2.14286Z" fill="#6D6F7A"/>
            </svg>
          </slot>
        </div>

        <p class="title">Drag file di sini atau klik untuk upload</p>
        <p class="subtitle">
          File yang di dukung: PNG, JPG, JPEG, PDF
        </p>

        <button
          type="button"
          class="upload-btn"
          :disabled="disabled"
          @click="triggerUpload"
        >
          Upload File
        </button>
      </div>
    </div>
  </div>
</template>

<script>
export default {
  name: 'UploadField',
  props: {
    modelValue: File,
    accept: {
      type: String,
      default: '.png,.jpg,.jpeg,.pdf'
    },
    disabled: {
      type: Boolean,
      default: false
    }
  },
  data () {
    return {
      dragover: false,
      previewUrl: null,
      previewType: null // 'image' | 'file'
    }
  },
  watch: {
    modelValue: {
      immediate: true,
      handler (file) {
        if (!file) {
          this.previewUrl = null
          this.previewType = null
          return
        }

        if (file.type.startsWith('image/')) {
          this.previewUrl = URL.createObjectURL(file)
          this.previewType = 'image'
        } else {
          this.previewUrl = null
          this.previewType = 'file'
        }
      }
    }
  },
  methods: {
    triggerUpload () {
      this.$refs.fileInput.click()
    },
    onFileChange (e) {
      const file = e.target.files[0]
      if (file) this.$emit('update:modelValue', file)
    },
    onDragOver () {
      if (!this.disabled) this.dragover = true
    },
    onDragLeave () {
      this.dragover = false
    },
    onDrop (e) {
      this.dragover = false
      if (this.disabled) return
      const file = e.dataTransfer.files[0]
      if (file) this.$emit('update:modelValue', file)
    },
    removeFile () {
      this.previewUrl && URL.revokeObjectURL(this.previewUrl)
      this.previewUrl = null
      this.previewType = null
      this.$emit('update:modelValue', null)
    },

    formatSize (bytes) {
      if (!bytes) return ''
      const kb = bytes / 1024
      if (kb < 1024) return `${kb.toFixed(1)} KB`
      return `${(kb / 1024).toFixed(1)} MB`
    }
  }
}
</script>

<style scoped>
.upload-field {
  display: flex;
  align-items: center;
  justify-content: center;
  border: 2px dashed #d0d5dd;
  border-radius: 12px;
  padding: 32px;
  text-align: center;
  background: #fff;
  transition: all 0.2s ease;
  min-height: 320px;
}

.upload-field.dragover {
  border-color: #4c66a4;
  background: #f5f7ff;
}

.upload-field.disabled {
  opacity: 0.6;
  pointer-events: none;
}

.hidden-input {
  display: none;
}

.content {
  display: flex;
  flex-direction: column;
  align-items: center;
  gap: 2px;
}

.icon {
  width: 48px;
  height: 48px;
  border-radius: 50%;
  border: 1px solid #d0d5dd;
  display: flex;
  align-items: center;
  justify-content: center;
}

.title {
  font-weight: 600;
  color: #3c3f44;
}

.subtitle {
  font-size: 13px;
  color: #667085;
}

.upload-btn {
  margin-top: 8px;
  padding: 10px 16px;
  border-radius: 8px;
  border: 1.5px solid #4c66a4;
  background: #fff;
  color: #4c66a4;
  font-weight: 600;
  cursor: pointer;
}

.upload-container {
  width: 100%;
}

/* PREVIEW */
.preview-wrapper {
  position: relative;
  border-radius: 12px;
  overflow: hidden;
  background: #f9fafb;
  border: 2px dashed #d0d5dd;
  padding: 6px;

  height: 411px;
  max-height: 320px;
  width: 100%;
}

.preview-wrapper img {
  width: 100%;
  height: 100%;
  display: block;

  object-fit: contain;
  background: #fff;
}

/* DELETE BUTTON */
.delete-btn {
  position: absolute;
  top: 12px;
  right: 12px;
  background: #fff;
  border: none;
  border-radius: 8px;
  padding: 6px 8px;
  cursor: pointer;
  font-size: 14px;
  box-shadow: 0 2px 6px rgba(0,0,0,.1);
}

/* FILE PREVIEW (PDF) */
.file-preview {
  position: relative;
  border: 2px dashed #d0d5dd;
  border-radius: 12px;
  padding: 20px;

  height: 411px;
  display: flex;
  align-items: center;
  justify-content: center;
}

.file-info {
  display: flex;
  align-items: center;
  gap: 16px;
}

.file-icon {
  width: 48px;
  height: 48px;
  border-radius: 8px;
  background: #f2f4f7;

  display: flex;
  align-items: center;
  justify-content: center;
}

.file-name {
  font-weight: 600;
  color: #3c3f44;
  max-width: 420px;
  word-break: break-all;
}

.file-size {
  font-size: 13px;
  color: #667085;
}
</style>
